import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorService } from 'services/error.service';
import { ProspectService } from 'services/prospect.service';
import { SplashService } from 'services/splash.service';

@Component({
  selector: 'app-locate-agree',
  templateUrl: './locate-agree.component.html',
  styleUrls: ['./locate-agree.component.css']
})
export class LocateAgreeComponent implements OnInit {

  errorMessage: string = null;
  render: boolean = false;

  constructor(private router: Router, private prospectService: ProspectService, private errorService: ErrorService, private splashService: SplashService) {
   }

  ngOnInit() {
    this.splashService.updateSplash("selftour");
  }

  locateAgree(){
    this.prospectService.LocationAgreement().subscribe(res => this.onLocateAgree(res), err =>  this.errorService.showError(err));
  }

  onLocateAgree(result: any)
  {
    this.router.navigate(['/tour/selftour-start/verify-location']);
  }

}
